export { default as Summeryreport } from "./Survey/ManageSurvey/SummaryReport/Summeryreport";
export { default as CreateSurvey } from "./Survey/CreateSurvey";
export { default as EditBasicInfo } from "./Survey/CreateBasicInfo/EditBasicInfo/EditBasicInfo";
export { default as ClientDetails } from "./Survey/ClientView/ClientDetails";
export { default as SurveyAnalytics } from "./Survey/SurveyAnalytics/SurveyAnalytics";
export { default as ManageFonts } from "./Survey/ManageFonts/ManageFonts";
export { default as NewThankYou } from "./Survey/ClientView/ThankYou/NewThankYou";
export { default as NewSurveySubmitted } from "./Survey/ClientView/SubmittedSurvey/NewSurveySubmitted";
